export const cardStyles = 'bg-surface rounded-md shadow mb-6';
